import { AbrirConfirmAgendamentoFuturo, AbrirDetalhes, AbrirGestaoConviteEventoPage, AbrirPesqSatisfacao, ComunicadosBenef, OpenComunic, TipoComunicado } from "../../interfaces/entities/ComunicadosBenef"
import { NotificationEnum } from "../../interfaces/enum/NotificationEnum"

export const defaultAbrirDetalhes: AbrirDetalhes = {
    titulo: '',
    descricao: '',
    descricaoBotao: '',
    paginaRedirecionamento: ''
}

export const defaultAbrirPesqSatisfacao: AbrirPesqSatisfacao = {
    idQuestOperador: 0,
    idComunic: 0,
    titulo: '',
    subTitulo: ''
}

export const defaultAbrirConfirmAgendamentoFuturo: AbrirConfirmAgendamentoFuturo = {
    idAgenda: 0,
    tipo: ''
}

export const defaultAbrirGestaoConviteEventoPage: AbrirGestaoConviteEventoPage = {
    idEventoUsr: '',
}

export const defaultOpenComunic: OpenComunic = {
    tipoSelecionado: '',
    abrirAutomatico: '',
    abrirPesqSatisfacao: defaultAbrirPesqSatisfacao,
    abrirConfirmAgendamentoFuturo: defaultAbrirConfirmAgendamentoFuturo,
    abrirMeusAgendamentoDetalhe: '',
    abrirDetalhes: defaultAbrirDetalhes,
    abrirPagina: '',
    abrirGestaoConviteEventoPage: defaultAbrirGestaoConviteEventoPage,
}

export const defaultTipoComunic: TipoComunicado = {
    idTipoComunicado: 8,
    descr: '',
    indPermiteExclusao: '',
    indAbrirAutomatico: '',
    indAbrirPesquisaSatisfacao: '',
    qtdNaoLido: 0,
    codigo: ''
}

export const defaultNotification: ComunicadosBenef = {
    idComunic: 0,
    tipoComunic: defaultTipoComunic,
    titulo: '',
    descr: '',
    indLido: '',
    dtLido: '',
    indAnexo: '',
    indExclusao: '',
    dtExcl: new Date(),
    dtIncl: new Date(),
    openComunic: defaultOpenComunic,
    tipoNotificacao: NotificationEnum.Mensagem
}
